import React, { Component } from 'react';
// import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { logActivity } from '../../../services/utilService';
import CustomLoader from '../../common/Loader';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getDataSources } from '../../../services/dataSourceService';
import { getSPV, getResultSourceTypes, getDisplayEditInfoDSColumns, saveDisplayEditInfo, getDisplayEditInfo } from '../../../services/formService';
import * as Icon from 'react-feather';
import { ResultSource } from '../../../constants/ResultSource';
class WDisplayEditInfo extends Component {

    DataSources = [];
    StoredProcedures = [];
    Views = [];

    state = {
        Project_ID: this.props.Project_ID,
        Form_ID: parseInt(this.props.Form_ID),
        Widget_ID: this.props.Widget.Widget_ID,
        DEI_ID: 0,
        DataSource_ID: 0,
        ResultSource_ID: 0,
        ResultSource_Content: '',
        Display_Name: '',
        open_options: '',
        loading: true,
        displayColumns: [],
        optionsSPCols: ['Select Column'],
        connStr: null,
        isSPParameterized: false
    };

    /* Comp Pre-Render */
    constructor(props) {
        super(props);
        this.handleSave = this.handleSave.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    /* Comp Set initial states after render */
    async componentDidMount() {
        const { data: dataDS } = await getDataSources();
        this.DataSources = dataDS;
        const { data: ResultSources } = await getResultSourceTypes();

        const { data: preloadData } = await getDisplayEditInfo(this.state.Widget_ID);
        if (preloadData[0]) {
            this.setState({
                DEI_ID: preloadData[0].DEI_ID || 0,
                ResultSources: JSON.parse(ResultSources.resultSources),
                DataSource_ID: parseInt(preloadData[0].DataSource_ID) || 0,
                ResultSource_ID: preloadData[0].ResultSource_ID || 0,
                Display_Name: preloadData[0].Display_Name || '',
                ResultSource_Content: preloadData[0].ResultSource_Content !== null ? preloadData[0].ResultSource_Content : '',
                open_options: preloadData[0].ResultSource_Content !== null ? preloadData[0].ResultSource_Content : '',
                connStr: null,
                isSPParameterized: preloadData[0].isSPParameterized
            });
            //(this.state.ResultSource_ID === 2) && this.setState({ isSPParameterized: preloadData[0].isSPParameterized })
            this.setColData(preloadData[0]).then(
                (preloadData) => {
                    this.setState({ displayColumns: JSON.parse(preloadData.jsonColumns) })
                }
            )
            this.getAutoCompleteOptions(preloadData[0].ResultSource_ID);
        }
        else {
            this.handleAddColumn(0)
            this.setState({
                ResultSources: JSON.parse(ResultSources.resultSources),
                DataSource_ID: 0,
                connStr: null
            });
        }
        this.setState({ loading: false })
    }

    setColData(preloadData) {
        this.getDisplayColumnsOptions(preloadData.ResultSource_Content !== null ? preloadData.ResultSource_Content : '')
        return Promise.resolve(preloadData)
    }

    /* Add Comp functionalities below */
    getAutoCompleteOptions = async (value) => {
        const { data } = await getSPV(value, this.getConn());
        if (value === ResultSource.SP) {
            this.StoredProcedures = data;
        } else if (value === ResultSource.View) {
            this.Views = data;
        }
    };

    getDisplayColumnsOptions = async (parentName) => {
        if (parentName !== '') {
            try {
                let autoCompleteVal = (typeof parentName === 'string') ? parentName : this.state.ResultSource_Content,
                    connStr = await this.getConn();
                this.setState({ connStr, ResultSource_Content: autoCompleteVal });
                const { data: optionsSPCols } = await getDisplayEditInfoDSColumns(this.state, 'builder');
                if (typeof optionsSPCols === 'string' && optionsSPCols.toLowerCase().includes('error')) {
                    toaster('error', 'Error: Retrieving Column Options for the selected Data Source');
                    this.setState({ optionsSPCols: [] });
                }
                else {
                    this.setState({ optionsSPCols: JSON.parse(optionsSPCols.replace(/'/g, '"')) || [] });
                    let input = { name: 'ColumnID_', value: JSON.parse(optionsSPCols.replace(/'/g, '"'))[0] };
                    this.handleChange(input, 0);
                    
                }
            }
            catch (e) {
                toaster('error', 'Error: Retrieving Column Options for the selected Data Source');
            }
        }
        else {
            this.setState({ optionsSPCols: [] });
            this.setState({ displayColumns: [{ 'Column_ID': 0, 'Column_Name': '', 'isEditable': false, 'enableCopy': false }] });
        }
    }

    getConn() {
        const source = this.DataSources.find((source) => {
            return source.DataSource_ID === parseInt(this.state.DataSource_ID);
        });
        return source.Connection_String;
    }

    handleAddColumn(idx) {
        //console.log("handleAddColumn", idx)
        const displayColumns = [...this.state.displayColumns, { 'Column_ID': idx, 'Column_Name': this.state.optionsSPCols[0], 'isEditable': false, 'enableCopy': false }];
        this.setState({ displayColumns });
    }

    handleRemoveColumn(idx) {
        let displayColumns = [...this.state.displayColumns];
        displayColumns = this.state.displayColumns.filter(function (col, index) {
            return index !== idx;
        });
        this.setState({ displayColumns });
    }

    handleSPVChange = async (e, value) => {
        value = (value !== null) ? value : '';
        this.setState({ ResultSource_Content: '' });
        this.getDisplayColumnsOptions(value);
        this.setState({ ResultSource_Content: value, open_options: value });
    };

    handleResultSourceChange = async (input) => {
        const name = input.name.split(':').pop();
        let value = parseInt(input.value);
        this.setState({ [name]: value });
        this.getAutoCompleteOptions(value);
    };


    handleChange = (input, idx) => {
        this.setState({ [input.name]: input.value });
        let displayColumns = this.state.displayColumns
        if ((input.name).includes('ColumnID_')) {
            displayColumns[idx]['Column_ID'] = idx
            displayColumns[idx]['Column_Name'] = input.value
        }
        else if ((input.name).includes('col-checkbox_edit')) {
            displayColumns[idx]['isEditable'] = !displayColumns[idx]['isEditable']
        }
        else if ((input.name).includes('col-checkbox_copy')) {
            displayColumns[idx]['enableCopy'] = !displayColumns[idx]['enableCopy']
        }
        else if ((input.name).includes('isSPParameterized')) {
            this.setState({ isSPParameterized: !this.state.isSPParameterized })
        }
        this.setState({ displayColumns })
    };

    handleSave = async () => {
        try {
            if (this.state.ResultSource_Content && this.state.displayColumns.length > 0 && this.state.displayColumns[0].Column_Name !== '') {
                const { data } = await saveDisplayEditInfo(this.state);
                if (data.includes('Error')) {
                    toaster('error', data);
                    logActivity('/formBuilder', 'WIDGET_DISPLAYEDITINFO_SAVE_FAILED');
                } else {
                    toaster('success', 'Display/Edit Info saved.');
                    logActivity('/formBuilder', 'WIDGET_DISPLAYEDITINFO_SAVE_SUCCESS');
                    const DT_ID = data.split(':').pop();
                    this.setState({ DT_ID });
                }
            }
            else {
                toaster('error', 'Please Fill out right settings.');
            }
        }
        catch (e) {
            toaster('error', 'Display/Edit Info could not be saved.');
        }
    };

    handleRemove = () => {
        this.props.onRemove(this.state.Widget_ID);
    };

    /* Comp Render */
    render() {

        const { loading, Widget_ID, DataSource_ID, ResultSource_ID, Display_Name, ResultSource_Content, ResultSources, open_options, displayColumns } = this.state;
        if (loading) {
            return <CustomLoader loading={loading} />;
        }
        try {
            return (
                <React.Fragment>
                    <div className='form-group' key={Widget_ID}>
                        <label htmlFor={'Display_Name' + Widget_ID}>Display Name</label>
                        <input
                            className='form-control'
                            id={'Display_Name' + Widget_ID}
                            type='text'
                            name='Display_Name'
                            value={Display_Name}
                            onChange={(e) => this.handleChange(e.target)}
                        />
                    </div>
                    <div className='form-group'>
                        <label htmlFor={'DataSource' + Widget_ID}>Data Source</label>
                        <select
                            id={'DataSource' + Widget_ID}
                            className='form-control'
                            value={DataSource_ID}
                            name='DataSource_ID'
                            onChange={(e) => this.handleChange(e.target)}
                        >
                            <option value='0'>Select</option>
                            {this.DataSources.map((source) => {
                                return (
                                    <option key={source.DataSource_ID} value={source.DataSource_ID}>
                                        {source.Description}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    {/* DB DataSource Elements */}
                    {DataSource_ID !== 0 && (
                        <React.Fragment>
                            <div className='form-group'>
                                {ResultSources.map((source, index) => {
                                    return (
                                        <div className='form-check form-check-inline' key={Widget_ID + source.ResultSource_Type_Name}>
                                            <input
                                                type='radio'
                                                className='form-check-input'
                                                id={Widget_ID + source.ResultSource_Type_Name}
                                                name={Widget_ID + ':ResultSource_ID'}
                                                value={source.ResultSource_ID}
                                                checked={source.ResultSource_ID === ResultSource_ID}
                                                onChange={(e) => this.handleResultSourceChange(e.target)}
                                                onClick={(e) => this.handleResultSourceChange(e.target)}
                                            />
                                            <label
                                                htmlFor={Widget_ID + source.ResultSource_Type_Name}
                                                className='form-check-label'
                                            >
                                                {source.ResultSource_Type_Name}
                                            </label>
                                        </div>
                                    );
                                })}

                                {ResultSource_ID === ResultSource.Query && (
                                    <div>
                                        <TextField
                                            id={Widget_ID + 'resultSourceContent'}
                                            label='Enter Query'
                                            variant='outlined'
                                            fullWidth
                                            margin='dense'
                                            name='ResultSource_Content'
                                            value={ResultSource_Content}
                                            onChange={(e) => this.handleChange(e.target)}
                                        />
                                    </div>
                                )}

                                {(ResultSource_ID === ResultSource.SP ||
                                    ResultSource_ID === ResultSource.View) && (
                                        <div>
                                            <Autocomplete
                                                id={Widget_ID + 'resultSourceContent'}
                                                options={
                                                    open_options
                                                        ? ResultSource_ID === ResultSource.SP
                                                            ? this.StoredProcedures : this.Views
                                                        : []
                                                }
                                                getOptionLabel={(option) => option}
                                                fullWidth
                                                size='small'
                                                value={ResultSource_Content}
                                                name='ResultSource_Content'
                                                onChange={this.handleSPVChange}
                                                onClick={this.handleSPVChange}
                                                inputValue={open_options}
                                                onInputChange={(e, val) => { this.setState({ open_options: val || '' }); }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={ResultSource_ID === ResultSource.SP ? 'Stored Procedure Name' : 'View Name'}
                                                    />
                                                )}
                                            />
                                            {/* Bind to SP Params */}
                                            <div>
                                                <label htmlFor={Widget_ID + '_isSPParameterized'} className='form-check-label mr-1'> Is Widget information based on Identifier?</label>
                                                <input
                                                    type='checkbox'
                                                    title='Pass Identifier to Search?'
                                                    className='form-group mt-3 ml-4 displayEditInfo_cb'
                                                    id={Widget_ID + '_isSPParameterized'}
                                                    name={Widget_ID + ':isSPParameterized'}
                                                    checked={(this.state.isSPParameterized ? 'checked' : '')}
                                                    value={this.state.isSPParameterized}
                                                    onChange={(e) => this.handleChange(e.target)}
                                                />
                                            </div>
                                        </div>
                                    )}
                            </div>
                        </React.Fragment>
                    )}

                    {/* display columns render */}
                    <React.Fragment>
                        <label className='col-md-3 mr-3'>Column Name</label>
                        <label className='mr-4'>Edit</label>
                        <label>Copy</label>
                        <div className='form-group'>
                            {displayColumns.map((col, idx) => {
                                return (
                                    <div className={'colgroup-' + idx + ' form-row'}>
                                        <select
                                            id={'ColumnID_' + idx}
                                            name={'ColumnID_' + idx}
                                            className='form-control form-group col-md-3 mr-4'
                                            onChange={(e) => this.handleChange(e.target, idx)}
                                            value={col.Column_Name}
                                        >
                                            {this.state.optionsSPCols.map((SPColVal, id) => {
                                                return (
                                                    <option key={id} name={SPColVal} value={SPColVal}>
                                                        {SPColVal}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                        <input type='checkbox' title='Enable Edit?' className='form-group mt-3 mr-5 displayEditInfo_cb' name={'col-checkbox_edit' + idx} checked={(col.isEditable ? 'checked' : '')} value={col.isEditable} onChange={(e) => this.handleChange(e.target, idx)} />
                                        <input type='checkbox' title='Enable Copy?' className='form-group mt-3 mr-5 displayEditInfo_cb' name={'col-checkbox_copy' + idx} checked={(col.enableCopy ? 'checked' : '')} value={col.enableCopy} onChange={(e) => this.handleChange(e.target, idx)} />
                                        <button className='btn btn-outline-primary btn-icon btn-sm mt-2 mr-2' onClick={() => this.handleAddColumn(idx + 1)}>
                                            <Icon.Plus size={20} />
                                        </button>
                                        <div className='form-group col-md-1'>
                                            {this.state.displayColumns.length > 1 && idx !== 0 && (
                                                <button className='btn btn-outline-danger btn-icon btn-sm mt-2 mr-2' onClick={() => this.handleRemoveColumn(idx)}>
                                                    <Icon.Minus size={20} />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </React.Fragment>

                    {/* common widget elements */}
                    <div className='d-flex justify-content-end'>
                        <button className='btn btn-outline-primary mr-2' onClick={this.handleSave}>
                            Save
                        </button>
                        <button className='btn btn-outline-danger' onClick={this.handleRemove}>
                            Delete
                        </button>
                    </div>
                    {/* <ToastContainer /> */}
                </React.Fragment>
            );
        }
        catch (e) {
            return <p>Error Loading Widget!</p>
        }
    }

}

export default WDisplayEditInfo;